// Application JavaScript entrypoint
console.log('Vite Rails')
